import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routesP = [
    {
        path: '/',
        name: 'Index',
        component: () => import( /* webpackChunkName: “about” */ '@/pages/pc/index.vue'),
    },
    {
        path: '/recruit',
        name: 'recruit',
        component: () => import( /* webpackChunkName: “about” */ '@/pages/pc/recruit.vue'),
    },
    {
        path: '/benefits',
        name: 'benefits',
        component: () => import( /* webpackChunkName: “about” */ '@/pages/pc/benefits.vue'),
    },
    // children: [
        // {
        //   path: '/recruit',
        //   name: 'recruit',
        //   component: () => import('@/pages/pc/recruit.vue'),
        //   markName: '/recruit',
        //   meta: { title: '招聘信息' }
        // }
    // ]
]

const routesM = [
    {
        path: '/',
        name: 'Index',
        component: () => import( /* webpackChunkName: “about” */ '@/pages/mobile/index.vue')
    },
    {
        path: '/recruit',
        name: 'recruit',
        component: () => import( /* webpackChunkName: “about” */ '@/pages/mobile/recruit.vue')
    },
    {
        path: '/benefits',
        name: 'benefits',
        component: () => import( /* webpackChunkName: “about” */ '@/pages/mobile/benefits.vue'),
    },
]

var routes = [];
if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
    routes = routesM
} else {
    routes = routesP
}

const router = new VueRouter({
    // mode: 'history',
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router